/**
 * identity function (identity :: a -> a)
 * returns the passed param
 * @global
 * @param { T } x any param
 * @returns { T } x
 * @template T
 */
export const identity = x => x
